import {IntermediatePart} from "../../intermediatePart";

export default class Ceiling extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'walls_ceiling';
    this.partName = 'Ceiling';
    this.translateId = "visualizer.kitchen.walls.walls_ceiling";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Ceiling());
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Walls.Ceiling;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
